import {
  Briefcase,
  Coins,
  Heart,
  LucideIcon,
  Plane,
  Sparkles,
  Star,
} from 'lucide-react';

// Fonte unica de perfis e paleta partilhada entre Insights Lite e Pro, para que
// os cartoes de score partilhem design e comportamento (PL-005).
export const PROFILE_KEYS = ['Investment', 'Relationships', 'Health', 'Spiritual', 'Career', 'Travel'];

export type ProfileVisual = {
  icon: LucideIcon;
  cardClass: string;
  iconClass: string;
  progressClass: string;
  textClass: string;
};

// Paleta alinhada com os cards da Insights (Pro) e da Lite para manter coerencia
// de design entre as duas vistas.
export const PROFILE_VISUALS: Record<string, ProfileVisual> = {
  Investment: {
    icon: Coins,
    cardClass: 'border-emerald-200 bg-gradient-to-br from-emerald-50 to-green-50',
    iconClass: 'text-emerald-500',
    progressClass: 'bg-emerald-500',
    textClass: 'text-emerald-700',
  },
  Relationships: {
    icon: Heart,
    cardClass: 'border-pink-200 bg-gradient-to-br from-pink-50 to-rose-50',
    iconClass: 'text-pink-500',
    progressClass: 'bg-pink-500',
    textClass: 'text-pink-700',
  },
  Health: {
    icon: Sparkles,
    cardClass: 'border-amber-200 bg-gradient-to-br from-amber-50 to-yellow-50',
    iconClass: 'text-amber-500',
    progressClass: 'bg-amber-500',
    textClass: 'text-amber-700',
  },
  Spiritual: {
    icon: Star,
    cardClass: 'border-purple-200 bg-gradient-to-br from-purple-50 to-violet-50',
    iconClass: 'text-purple-500',
    progressClass: 'bg-violet-500',
    textClass: 'text-purple-700',
  },
  Career: {
    icon: Briefcase,
    cardClass: 'border-blue-200 bg-gradient-to-br from-blue-50 to-sky-50',
    iconClass: 'text-blue-500',
    progressClass: 'bg-blue-500',
    textClass: 'text-blue-700',
  },
  Travel: {
    icon: Plane,
    cardClass: 'border-cyan-200 bg-gradient-to-br from-cyan-50 to-teal-50',
    iconClass: 'text-cyan-500',
    progressClass: 'bg-cyan-500',
    textClass: 'text-cyan-700',
  },
};

export const getProfileVisual = (profileKey: string | undefined): ProfileVisual =>
  PROFILE_VISUALS[profileKey ?? ''] ?? PROFILE_VISUALS.Career;
